export default "https://docs.trustwillow.com/apiresponses/learncategoriesall1.json"